import Error from "next/error";
import React from "react";
import Head from "next/head";

import UPSMain from "@/components/fulfilment-partners/ups-main";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

type Props = {
  partner: string;
};

const DigitalAccessProgram = ({ partner }: Props) => {
  if (partner != "ups") {
    return <Error statusCode={404} title="Page Not Found" />;
  }
  return (
    <>
      <Head>
        <title>{seoData.PARTNER_UPS.title}</title>
        <SeoMetaData
          data={{
            ...seoData.PARTNER_UPS,
            canonicalUrl: `${seoData.PARTNERS.canonicalUrl}/ups/digital-access-program`,
          }}
        />
      </Head>

      <UPSMain />
    </>
  );
};

export async function getServerSideProps(context: any) {
  const { partner } = context.params;

  return {
    props: { partner }, // will be passed to the page component as props
  };
}

export default DigitalAccessProgram;
